import { showPaymentDetailsForUser } from './userHelpers';

/**
 * Sentinel `currentPage` value for the embedded account nav when no account
 * sub-route is active (e.g. seller dashboard overview).
 */
export const SELLER_SIDEBAR_NO_ACCOUNT_PAGE = 'SellerDashboardPage';

/**
 * Props for `LayoutWrapperAccountSettingsSideNav` when embedded under the
 * seller sidebar Settings group.
 *
 * @param {Object} config — marketplace config
 * @param {Object} currentUser
 * @param {string} [activeAccountPage] — e.g. `ContactDetailsPage`; omit on dashboard for no selection
 * @returns {{ currentPage: string, showPaymentMethods: boolean, showPayoutDetails: boolean }}
 */
export const getSellerEmbeddedAccountNavProps = (config, currentUser, activeAccountPage) => {
  const { showPayoutDetails, showPaymentMethods } = showPaymentDetailsForUser(config, currentUser);
  return {
    currentPage: activeAccountPage || SELLER_SIDEBAR_NO_ACCOUNT_PAGE,
    showPaymentMethods,
    showPayoutDetails,
  };
};
